import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Badge from "../../components/common/Badge";

export default function DashboardTab() {
  const { db } = useData();
  const rev = (db.orders || []).filter(o => o.status === "delivered").reduce((s, o) => s + o.amount, 0);

  return (
    <>
      <div className="grid-4" style={{ marginBottom: 18 }}>
        {[["Rs." + rev.toLocaleString(), "Revenue Delivered", C.teal, "📦"], [(db.leads || []).filter(l => l.status === "new").length, "New Leads", C.orange, "📋"], [(db.products || []).filter(p => p.stock <= 15).length, "Low Stock", C.red, "⚠️"], [(db.jobs || []).filter(j => j.status === "open").length, "Open Jobs", C.blue, "💼"]].map(([v, l, col, ic]) => (
          <div key={l} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "15px 17px", borderLeft: "4px solid " + col, boxShadow: "0 2px 8px rgba(0,0,0,.04)" }}>
            <div style={{ fontSize: 17, marginBottom: 6 }}>{ic}</div>
            <div style={{ fontSize: 23, fontWeight: 800, color: col, lineHeight: 1 }}>{v}</div>
            <div style={{ fontSize: 12, color: "#64748b", fontWeight: 600, marginTop: 4 }}>{l}</div>
          </div>
        ))}
      </div>
      <div className="grid-2">
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 17px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
          <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 11 }}>Recent Leads</h3>
          {(db.leads || []).slice(0, 4).map(l => (
            <div key={l.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
              <div><div style={{ fontSize: 13, fontWeight: 600, color: C.dark }}>{l.name}</div><div style={{ fontSize: 11, color: "#94a3b8" }}>{l.service} · {l.date}</div></div>
              <Badge v={l.status} />
            </div>
          ))}
        </div>
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 17px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
          <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 11 }}>Low Stock Alert</h3>
          {(db.products || []).filter(p => p.stock <= 15).slice(0, 6).map(p => (
            <div key={p.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
              <span style={{ fontSize: 13, color: C.dark, fontWeight: 600 }}>{p.name}</span>
              <span style={{ fontSize: 12, fontWeight: 700, color: p.stock <= 5 ? C.red : C.amber }}>{p.stock} left</span>
            </div>
          ))}
        </div>
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 17px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
          <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 11 }}>Recent Orders</h3>
          {(db.orders || []).slice(0, 4).map(o => (
            <div key={o.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
              <div><div style={{ fontSize: 13, fontWeight: 600, color: C.dark }}>{o.id} - {o.customer}</div><div style={{ fontSize: 11, color: "#94a3b8" }}>Rs.{o.amount.toLocaleString()} · {o.date}</div></div>
              <Badge v={o.status} />
            </div>
          ))}
        </div>
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 17px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
          <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 11 }}>DB Summary</h3>
          {[["Products", (db.products || []).length, C.teal], ["Orders", (db.orders || []).length, C.blue], ["Leads", (db.leads || []).length, C.orange], ["Open Jobs", (db.jobs || []).filter(j => j.status === "open").length, C.blue], ["Testimonials", (db.testimonials || []).filter(t => t.status === "published").length, "#7c3aed"], ["Certifications", (db.certifications || []).length, "#0f766e"]].map(([l, v, c]) => (
            <div key={l} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: "1px solid #f1f5f9" }}>
              <span style={{ fontSize: 13, color: "#64748b" }}>{l}</span><span style={{ fontSize: 13, fontWeight: 700, color: c }}>{v}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
